// client/src/coms/views/WatchTogetherView.js
import React, { useMemo } from 'react';
import { isTauriApp } from '../auth/providerAuth';
import { useWatchTogetherController } from './watch_together_parts/useWatchTogetherController';
import WatchTogetherGate from './watch_together_parts/WatchTogetherGate';
import WatchTogetherQueuePanel from './watch_together_parts/WatchTogetherQueuePanel';
import WatchTogetherPlayerPanel from './watch_together_parts/WatchTogetherPlayerPanel';
import './canvas_parts/party/partyGames.css';

export default function WatchTogetherView({ server, user, voiceRoom, voiceSession }) {
  const controller = useWatchTogetherController({
    server,
    user,
    voiceRoom,
    voiceSession,
  });

  const isApp = isTauriApp();

  const spotifyConnected = !!controller.spotifySession;
  const spotifyAccountLabel = String(
    controller.spotifySession?.profile?.display_name ||
    controller.spotifySession?.profile?.id ||
    ''
  ).trim();

  const headerMeta = useMemo(() => {
    return {
      title: 'Watch Together',
      description: spotifyConnected
        ? `Spotify connected${spotifyAccountLabel ? ` as ${spotifyAccountLabel}` : ''}.`
        : 'YouTube and Spotify are available.',
    };
  }, [spotifyAccountLabel, spotifyConnected]);

  if (!controller.room || !controller.room.localParticipant) {
    return <WatchTogetherGate />;
  }

  return (
    <div
      className="coms-view"
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
        height: '100%',
        padding: 18,
        boxSizing: 'border-box',
        gap: 16,
      }}
    >
      <div
        style={{
          border: '1px solid rgba(var(--vx-fg-rgb, 255,255,255), calc(0.10 * var(--vx-ov, 1)))',
          background: 'rgba(var(--vx-fg-rgb, 255,255,255), calc(0.03 * var(--vx-ov, 1)))',
          borderRadius: 16,
          padding: 16,
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          minHeight: 0,
          flex: 1,
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
            flexWrap: 'wrap',
          }}
        >
          <div>
            <div style={{ fontSize: 22, fontWeight: 900 }}>
              {headerMeta.title}
            </div>
            <div style={{ fontSize: 12, opacity: 0.7 }}>
              {headerMeta.description}
            </div>
          </div>

          {isApp ? (
            spotifyConnected ? (
              <button
                onClick={controller.disconnectSpotify}
                style={{
                  border: '1px solid rgba(var(--vx-fg-rgb, 255,255,255), calc(0.12 * var(--vx-ov, 1)))',
                  background: 'rgba(var(--vx-fg-rgb, 255,255,255), calc(0.04 * var(--vx-ov, 1)))',
                  color: 'var(--vx-text, #fff)',
                  borderRadius: 10,
                  padding: '10px 14px',
                  fontWeight: 800,
                  cursor: 'pointer',
                }}
              >
                Log out of Spotify
              </button>
            ) : (
              <button
                onClick={controller.connectSpotify}
                disabled={controller.spotifyAuthBusy}
                style={{
                  border: '1px solid rgba(29,185,84,0.55)',
                  background: 'rgba(29,185,84,0.24)',
                  color: 'var(--vx-text, #fff)',
                  borderRadius: 10,
                  padding: '10px 14px',
                  fontWeight: 800,
                  cursor: controller.spotifyAuthBusy ? 'not-allowed' : 'pointer',
                  opacity: controller.spotifyAuthBusy ? 0.6 : 1,
                }}
              >
                {controller.spotifyAuthBusy ? 'Logging in…' : 'Log in to Spotify'}
              </button>
            )
          ) : null}
        </div>

        {/* Queue beside the player; stacked on narrow screens (.vox-watch-grid in partyGames.css). */}
        <div className="vox-watch-grid">
          <WatchTogetherQueuePanel
            {...controller}
          />
          <WatchTogetherPlayerPanel {...controller} />
        </div>
      </div>
    </div>
  );
}